import $ from 'jquery';
import styles from './ui1.less';
import { iconfont,jsToCss,hexToRgb } from '../../utils/utils';
const btnClick = {
  logo:{onclick:''},
  author:{onclick:''},
  pv:{onclick:''},
  fullScreen:{onclick:'handleFullScreen()'},
  vr:{onclick:'handleVR()'},
  musicBg:{onclick:'handleMusicBg()'},
  musicExplain:{onclick:'handleMusicExplain()'},
  cruise:{onclick:'handleCruise()'},
  sandTable:{onclick:'handleSandTable()'},
  gyro:{onclick:'handleGyro()'},
  comment:{onclick:'commentDialog();'},
  fabulous:{onclick:'praise();'},
  share:{onclick:'handleShareClick()'},
  introduce:{onclick:'handleIntroduceClick()'},
  selectScene:{onclick:"handleActionBtnClick('selectScene','')"},
  link:{onclick:''},
  tel:{onclick:''},
  navigation:{onclick:''},
}
class ui {
  constructor(props){
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...params
    };
    this.cwh;
    this._initDom();
    window.addEventListener('resize', ()=>{
      this._getClientWH()
    });
  }

  _initDom() {
    this._removeDetailsBtn();
    const detailsBtnDom = document.getElementsByClassName(`${styles['attribute-wrapper2']}`);
    if (detailsBtnDom.length == 0) {
      this.$attribute2bom = this._createAttribute2();
    }else{
      this.$attribute2bom = $(detailsBtnDom);
    }

    this._initUi();
    $(this.wrapper).append(this.$attribute2bom);
    this._getClientWH();
  }

  _createAttribute2() {
    return $(
      `
        <div class="${styles['attribute-wrapper2']} ${styles['attribute-wrapper2-ui1']}" style="display:none"></div>
      `
    );
  }

  _initUi() {
    const { data } = this.params;
    let $detailsBtn;
    data.map(item=>{
      if (item.front_key == 'details') {
        $detailsBtn = `<div id="details-btn" class="${styles['details-btn']}" onClick="${item.onclick}">
          <img src="${item.url}" />
          <span>细节</span>
        </div>`;
        this.$attribute2bom.append($detailsBtn);
      }else{
        if (item.status == '2') return;
        let onClick = '';
        const front_key_arr = ['logo','author','pv','fullScreen','vr','musicBg','musicExplain','cruise','sandTable','gyro','comment','fabulous','share','introduce','selectScene'];
        if (front_key_arr.indexOf(item.front_key) > -1) {
          onClick = btnClick[item.front_key].onclick
        }else{
          if (item.front_key == 'link') {
            onClick = item.container.link ? "openUrl('"+item.container.link+"')" : '';
          }else if(item.front_key == 'tel'){
            onClick = item.container.phone ? "openUrl('tel:"+item.container.phone+"')" : '';
          }else if(item.front_key == 'navigation'){
            onClick = (item.event_data && item.event_data.action_data) ? "openUrl('/navigation?lat="+item.event_data.action_data.lat+'&lng='+item.event_data.action_data.lng+'&title='+document.title+'&addr='+item.event_data.action_data.province+item.event_data.action_data.city+item.event_data.action_data.district+item.event_data.action_data.address+"')" : '';
          }
        }
        let $uiBtn = `<div id="${item.front_key}" class="${styles['uiDiv']}" style="" onClick="${onClick};">
          <div id="${item.icon.name}" style="display:${item.icon.visible == 'true' ? 'block' : 'none'};width:${item.icon.width}px;height:${item.icon.height}px;margin:0 auto;background-image:url(${item.icon.url});background-repeat:no-repeat;background-size:100%;background-position: 0px 0px;"></div>
          <div id="${item.text.name}" style="display:${item.text.visible == 'true' ? 'block' : 'none'};overflow: hidden;white-space: nowrap;text-overflow: ellipsis;${jsToCss(item.text.css)}">${(item.text && item.text.html) ? item.text.html : '暂无标题'}</div>
        </div>`;
        $(this.wrapper).append($uiBtn);

        const front_key_menu =['menu_1','menu_2','menu_3'];
        if (front_key_menu.indexOf(item.front_key) > -1) {
          if (item.event_data && item.event_data.type == 'group' && item.event_data.data.children && item.event_data.data.children.length > 0) {
            let $submenu = this._initSubmenu(item.event_data,item.container.height);
            $(document.getElementById(`${item.front_key}`)).append($submenu);
          }else if(item.event_data && item.event_data.type == 'button' && item.event_data.data && item.event_data.data.action_data){
            document.getElementById(`${item.front_key}`).setAttribute('onClick','handleHotspotClick('+item.event_data.data.type+','+item.event_data.data.action_data+')')
          }
        }
      }
    })
  }
  _initSubmenu(data,offsetHeight) {
    let $submeunDiv = `<div class="${styles['submenu']}" style="bottom:${offsetHeight}px;"><div class="${styles['submenu_c']}">
      ${data.data.children.map(item=>{
        const actionData = (item.data && item.data.action_data) ? item.data.action_data : '{}';
        return `<div class="${styles['submenuItem']}" onclick='handleHotspotClick(${item.data && item.data.type ? item.data.type : 404},${actionData})'>
          ${(item.data && item.data.title) ? item.data.title : '暂无标题'}
        </div>`
      }).join('')}
    </div></div>`
    return $submeunDiv;
  }

  _removeDetailsBtn() {
    if (document.getElementsByClassName(`${styles['attribute-wrapper2']}`)) {
      $(document.getElementsByClassName(`${styles['attribute-wrapper2']}`)[0]).remove();
    }
  }

  _getClientWH(){
    this.cwh = {clientWidth:document.body.clientWidth,clientHeight:document.body.clientHeight};
    this._setPosition();
  }

  _setPosition(){
    const { data } = this.params;
    data.map(item=>{
      if (item.front_key != 'details') {
        this.$bthDom = document.getElementById(item.front_key);
        if (this.$bthDom == null) return;
        var bgRgba = hexToRgb(item.container.bgcolor);
        this.$bthDom.style = 'cursor:pointer; position: absolute; top:0;left:0;width:'+item.container.width+'px;border-radius:'+item.container.bgroundedge+';background-color:rgba('+bgRgba.r+','+bgRgba.g+','+bgRgba.b+','+item.container.bgalpha+');background-image:url('+item.container.containerBgUrl+');height:'+item.container.height+'px;' + this._getCoordinate(item);
      }
    })
  }

  _getCoordinate(item){
    let style = '';
    switch(item.container.align){
      case 'topleft':
        style = 'transform: translate(0px,0px) translate(0px,0px) translate('+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'top':
        style = 'transform: translate('+this.cwh.clientWidth/2+'px,0px) translate(-50%,0px) translate('+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'topright':
        style = 'transform: translate('+this.cwh.clientWidth+'px,0px) translate(-100%,0px) translate(-'+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'left':
        style = 'transform: translate(0px,'+this.cwh.clientHeight/2+'px) translate(0px,-50%) translate('+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'center':
        style = 'transform: translate('+this.cwh.clientWidth/2+'px,'+this.cwh.clientHeight/2+'px) translate(-50%,-50%) translate('+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'right':
        style = 'transform: translate('+this.cwh.clientWidth+'px,'+this.cwh.clientHeight/2+'px) translate(-100%,0px) translate(-'+item.container.x+'px,'+item.container.y+'px)';
        break;
      case 'bottomleft':
        style = 'transform: translate(0px,'+this.cwh.clientHeight+'px) translate(0,-100%) translate('+item.container.x+'px,-'+item.container.y+'px)';
        break;
      case 'bottom':
        style = 'transform: translate('+ this.cwh.clientWidth/2 +'px,'+this.cwh.clientHeight+'px) translate(-50%,-100%) translate('+item.container.x+'px,-'+item.container.y+'px)';
        break;
      case 'bottomright':
        style = 'transform: translate('+this.cwh.clientWidth+'px,'+this.cwh.clientHeight+'px) translate(-100%,-100%) translate(-'+item.container.x+'px,-'+item.container.y+'px)';
        break;
      default:;
    }
    return style;
  }

  //细节列表展示
  detailsShow(){
    const detailsBtn = this.$attribute2bom.find(`.${styles['details-btn']}`);
    this.$attribute2bom.css('display', 'block');
    detailsBtn.css('display', 'block');
  }
  //细节列表关闭
  detailsHide(){
    const detailsBtn = this.$attribute2bom.find(`.${styles['details-btn']}`);
    detailsBtn.css('display', 'none');
  }
  //可开关按钮状态控制
  setBtnBg(domId,bollean){
    this.$btnImg = document.getElementById(domId);
    if (this.$btnImg == null) return;
    if (bollean) {
      this.$btnImg.style.backgroundPosition = '0px 0px'
    }else{
      this.$btnImg.style.backgroundPosition = '0px 100%'
    }
  }

  setHtml(){
    const { data } = this.params;
    data.map(item=>{
      if (item.text && item.text.name) {
        $('#'+item.text.name).html(item.text && item.text.html ? item.text.html : '暂无标题');
      }
    });
  }

}
export default ui;